import { http, HttpResponse } from 'msw'

import { allDisputes } from '@/mocks/data/transactions/disputes'

import { isNumeric } from '@/utils/app/number'
import { api } from '@/utils/constants'

import { DisputesRequest } from '@/types/transactions/dispute'

export const getAllDisputes = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.DISPUTES}`,
    ({ request }) => {
        const url = new URL(request.url)
        const limitQuery = url.searchParams.get('limit')
        const offsetQuery = url.searchParams.get('offset')

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allDisputes.length > limit ? offset + limit : allDisputes.length

        const results = allDisputes.slice(offset, limitArray)

        const next =
            offset + results.length < allDisputes.length ? 'again' : undefined

        return HttpResponse.json<DisputesRequest>({
            next,
            results,
        })
    },
)
